module.exports = __webpack_public_path__ + "static/media/jasper.0e0a6853.jpeg";